<template>
	<div id="checkout-form">
		<checkout
			v-if="showSteps === true"
			:form-id="formId"
			:project-type="projectType"
			:event-id="eventId"
			:sellable-program-ids="sellableProgramIds"
			:event-form-scenario="fetchedData.scenario"
			:block="block"
			:fetched-data="fetchedData"
		/>
		<div v-else-if="showSteps === false" class="panel px-4 theme-darkgray">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<h2 class="title title-lg mb-4">
							Регистрация закрыта
						</h2>
						<div class="btn-panel text-center text-sm-left">
							<a
								id="checkout_jivosite_top"
								onclick="jivo_api.open(); return false;"
								href="javascript:void(0)"
								class="btn btn-outline-primary"
								role="button"
							>
								Получить консультацию
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Checkout from '@/components/checkout/Checkout.vue';
import moment from '~/utils/moment';

export default {
	name: 'PanelCheckoutForm',
	components: {
		Checkout,
	},
	props: ['block', 'fetchedData'],
	data() {
		return {
			showSteps: null,
		};
	},
	computed: {
		sellableProgramIds() {
			return this.block.content.sellable_program_ids;
		},
		formId() {
			return this.fetchedData.form_id;
		},
		eventId() {
			return this.fetchedData.id;
		},
		projectType() {
			return this.fetchedData.type_titles.title_default;
		},
	},
	created() {
		this.checkEndDate();
	},
	methods: {
		checkEndDate() {
			const today = moment().format('YYYY-MM-DD HH:mm');
			const datEnd = this.fetchedData.event_date_end;
			const end = moment(datEnd).format('YYYY-MM-DD HH:mm');
			this.showSteps = moment(today).isBefore(end);
		},
	},
};
</script>
